export const AppState = {
	LOADING: 'LOADING',
	READY: 'READY',
	IDLE: 'IDLE',
}

export const abc = 'abc'
